/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gh-page-content',
  template: '<ng-content></ng-content>',
  styleUrls: ['page-content.component.scss'],
})
export class PageContentComponent {

}
